<template>
  <v-container>
    <v-row align="center">
      <v-col>
        <p>{{ $t('describe_in_summary')}}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'OthersDetails',
  data: vm => ({})
}
</script>
